var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_3321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.02 8.50482C7.53333 7.57815 8.52 7.03148 9.09333 6.21148C9.7 5.35148 9.36 3.74482 7.64 3.74482C6.51333 3.74482 5.96 4.59815 5.72667 5.30482L4 4.57815C4.47333 3.15815 5.76 1.93815 7.63333 1.93815C9.2 1.93815 10.2733 2.65148 10.82 3.54482C11.2867 4.31148 11.56 5.74482 10.84 6.81148C10.04 7.99148 9.27333 8.35148 8.86 9.11148C8.69333 9.41815 8.62667 9.61815 8.62667 10.6048H6.7C6.69333 10.0848 6.61333 9.23815 7.02 8.50482ZM8.97333 13.2715C8.97333 14.0048 8.37333 14.6048 7.64 14.6048C6.90667 14.6048 6.30667 14.0048 6.30667 13.2715C6.30667 12.5382 6.90667 11.9382 7.64 11.9382C8.37333 11.9382 8.97333 12.5382 8.97333 13.2715Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.771484,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_3321"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.271484,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmark);
export default __webpack_public_path__ + "static/media/Questionmark.f0e752fd174fbcae320617c4998606ac.svg";
export { ForwardRef as ReactComponent };